import { API } from "../api/axios";
const END_POINT = "/marks/class";
const END_POINT_FILTER = "/course-period-exam-filter";
class NoteDetailService {
    getAll(id, params) {
        return API.get(`${END_POINT}/${id}`, params);
    }
    getFilterNote(id,params) {
        return API.get(`${END_POINT_FILTER}/${id}`, params);
    }

}

export default new NoteDetailService();
